// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import MembershipOpenInvoiceListPagingResultModel from '../../model/membership-open-invoice-list-paging-result-model';
import MembershipOpenInvoiceListPagingResultDTO from '../dto/membership-open-invoice-list-paging-result-dto';
import dtoSchema from '../schemas/membership-open-invoice-list-paging-result-schema';
import MembershipOpenInvoiceListModel from '../../model/membership-open-invoice-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class MembershipOpenInvoiceListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<MembershipOpenInvoiceListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => MembershipOpenInvoiceListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: MembershipOpenInvoiceListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<MembershipOpenInvoiceListPagingResultDTO>): MembershipOpenInvoiceListPagingResultModel;
  static toModel(dto: DeepPartial<MembershipOpenInvoiceListPagingResultDTO> | undefined | null): MembershipOpenInvoiceListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<MembershipOpenInvoiceListPagingResultDTO> | undefined | null): MembershipOpenInvoiceListPagingResultModel | undefined {
    return dto ? new MembershipOpenInvoiceListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<MembershipOpenInvoiceListPagingResultModel> | MembershipOpenInvoiceListPagingResultModel): MembershipOpenInvoiceListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as MembershipOpenInvoiceListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for MembershipOpenInvoiceListPagingResultModel, can not map to MembershipOpenInvoiceListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
